import usePageTitle from "@/lib/usePageTitle";

const HISTORY_IMG = "https://customer-assets.emergentagent.com/job_township-next-gen/artifacts/kfo6sbaf_township.png";

const History = () => {
  usePageTitle("History");
  return (
    <div data-testid="history-page">
      <div className="relative h-72 md:h-96 overflow-hidden">
        <img src={HISTORY_IMG} alt="Lake Eunice Town Hall building with accessible ramp and parking lot" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary/70 to-transparent" />
        <div className="absolute bottom-8 left-0 right-0 container-le">
          <div className="text-xs uppercase tracking-[0.25em] text-accent mb-2">Our Township</div>
          <h1 className="text-white font-heading text-4xl sm:text-5xl font-medium tracking-tight">History</h1>
        </div>
      </div>

      <article className="container-le py-16 md:py-20 max-w-3xl prose-le">
        <p className="editorial-caps">
          Lake Eunice Township sits in the lake country of Becker County, Minnesota — a place where pine, birch, and water shape the rhythm of daily life. Generations of families have built homes here along Cormorant Lake, Little Cormorant Lake, and Pearl Lake, drawing both work and rest from the land.
        </p>
        <p>
          The Township Board governs locally on behalf of residents, maintaining roads and right-of-ways, partnering with the Audubon Fire Department on dry-hydrants that draw water beneath winter ice, and stewarding programs from compost to chloride dust control.
        </p>
        <p>
          This website is a living archive of that work — meeting minutes, ordinances, notices, and reminders. Browse, ask questions, and reach out anytime. The township belongs to all of us.
        </p>

        <div className="mt-10 p-6 border-l-2 border-accent bg-muted/40 rounded-r-md">
          <div className="text-xs uppercase tracking-[0.2em] text-secondary mb-2">A Note from the Board</div>
          <p className="m-0">
            We welcome your feedback and ideas. If something on this site is incorrect, out of date, or missing — let us know on the <a href="/contact" className="text-primary link-underline">Contact page</a> or send us a message through the live chat in the bottom-right corner.
          </p>
        </div>
      </article>
    </div>
  );
};

export default History;
